import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@paladise/ui/components/ui/table'
import React from 'react'
import { creatorToolsMap, PlansTitle, PlansTypeId } from '../constants'
import InfoTooltip from './InfoTooltip'
import PlanTableItem from './PlanTableItem'
import { useTranslations } from 'next-intl'

function CreatorToolTable() {
  const t = useTranslations()
  return (
    <div className="mb-[77px]">
      <Table className="text-label-l1 min768:table hidden">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[280px]">
              {t('plans_creator_tools')}
            </TableHead>
            <TableHead> {t(PlansTitle[PlansTypeId.Basic])}</TableHead>
            <TableHead> {t(PlansTitle[PlansTypeId.Pro])}</TableHead>
            <TableHead> {t(PlansTitle[PlansTypeId.ProPls])}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody className="text-body">
          {Object.values(creatorToolsMap).map(item => (
            <TableRow key={item.key} className="bg-background-b1">
              <TableCell className="p-2 pl-5">
                <div className="flex items-end">
                  {t(item.key)}
                  {item.hint && <InfoTooltip text={t(item.hint)} />}
                </div>
              </TableCell>
              <TableCell className="py-2">
                <PlanTableItem data={item[PlansTypeId.Basic]} />
              </TableCell>
              <TableCell className="py-2">
                <PlanTableItem data={item[PlansTypeId.Pro]} />
              </TableCell>
              <TableCell className="py-2">
                <PlanTableItem data={item[PlansTypeId.ProPls]} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div className="min768:hidden block">
        <p className="text-callout text-label-l1 mb-6">
          {t('plans_creator_tools')}
        </p>
        <div className="border-b-glass-separators text-callout text-label-l1 grid grid-cols-3 border-b pb-4">
          <div> {t(PlansTitle[PlansTypeId.Basic])}</div>
          <div> {t(PlansTitle[PlansTypeId.Pro])}</div>
          <div> {t(PlansTitle[PlansTypeId.ProPls])}</div>
        </div>

        {Object.values(creatorToolsMap).map(item => (
          <div key={item.key} className="text-body text-label-l1">
            <div className="border-b-glass-separators flex items-center border-b py-2">
              {t(item.key)}
              {item.hint && <InfoTooltip text={t(item.hint)} />}
            </div>
            <div className="border-b-glass-separators grid grid-cols-3 border-b py-2">
              <div>
                <PlanTableItem data={item[PlansTypeId.Basic]} />
              </div>
              <div>
                <PlanTableItem data={item[PlansTypeId.Pro]} />
              </div>
              <div>
                <PlanTableItem data={item[PlansTypeId.ProPls]} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CreatorToolTable
